import { render, staticRenderFns } from "./EmArchBasicDataList.vue?vue&type=template&id=4052f373&"
import script from "./EmArchBasicDataList.vue?vue&type=script&lang=js&"
export * from "./EmArchBasicDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports